/**
 * Removes markdown headings and comments.
 * Use only for light-weight normalization for duplicate check length threshold calculation.
 */
export function normalizeForDuplicateThreshold(body: string): string {
  let result = body.replace(/^#{1,6}\s+.*$/gm, '')
  result = result.replace(/<!--[\s\S]*?-->/g, '')
  return result.trim()
}
